import { memo } from 'react';
import { BottomNavbar, Button } from 'components';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ArrowRight } from 'lucide-react';
import { useAnalytics } from 'analytics';
import { ANALYTICS_EVENTS } from 'analytics/events';

interface HomeBottomNavbarProps {
  onRecordButtonClick: () => void;
}

const Container = styled.div.attrs({
  className: 'flex w-full max-w-6xl mx-auto justify-center flex-col gap-2',
})``;

const Content = styled.div.attrs({
  className: 'flex justify-center',
})``;

const HomeBottomNavbar = ({ onRecordButtonClick }: HomeBottomNavbarProps) => {
  const { t } = useTranslation();
  const { trackEvent } = useAnalytics();

  return (
    <BottomNavbar>
      <Container>
        <Content>
          <Button
            fullWidth
            data-ph-no-autocapture
            onClick={() => {
              trackEvent(ANALYTICS_EVENTS.HOME_START_CONSULTATION);
              onRecordButtonClick();
            }}
          >
            {t('home.openCurrentPatient')}
            <ArrowRight />
          </Button>
        </Content>
      </Container>
    </BottomNavbar>
  );
};

export default memo(HomeBottomNavbar);
